//Almacenamos la informacion seleccionada del usuario en los campos
export async function insertValue(data, id, value) {
    Object.keys(data)?.map(item => {
        data[item]?.map(itemAtt => {
            if (itemAtt.id === id) {
                itemAtt.value = value
            }
            return true
        })
        return true
    })
}


//Validamos si los campos son requiridos y devolvemos la informacion para el guardado
export async function validateData(data, setError, valueField) {
    let errorField = {}
    let jsonSend = {}
    await Object.keys(data).map(item => {
        data[item]?.map(itemAtt => {
            if (itemAtt.obligatorio && !valueField[itemAtt.id]) {
                errorField[itemAtt.id] = "Este campo es Obligatorio"
            }
            jsonSend[itemAtt.id] = valueField[itemAtt.id]
            return true
        })
        return true
    })
    setError(errorField)
    if (Object.keys(errorField).length > 0) {
        return false
    }
    return jsonSend
}


//Formateamos la fecha para el guardado
export const getFormattedDate = (dateNew) => {
    let date = new Date(dateNew)

    let day = date.getDate()
    let month = date.getMonth() + 1
    let year = date.getFullYear()
    let hours = date.getHours()
    let minutes = date.getMinutes()

    if (month < 10) {
        return `${year}/0${month}/${day} ${hours}:${minutes}`
    } else {
        return `${year}/${month}/${day} ${hours}:${minutes}`
    }
}

//Vaciamos el formulario
export function clearForm(hooks) {
    let data = {}
    hooks(state => {
         Object.keys(state)?.map(item => {
            const renderItem = state[item]?.map(itemAtt => {
                itemAtt.value = undefined
                return itemAtt
            })
            data[item] = renderItem
            return true
        })  
   
        return (data)
    })
}